import { fetchApartments, fetchApartment, removeApartment } from '../repositories/apartment.repository'

const state = {
    apartments: [],
    apartment: null
}

const actions = {
    fetchApartments ({ commit }, fields = null) {
        return new Promise(resolve => fetchApartments(fields)
            .then(res => {
                commit('setApartments', res.data)
                resolve()
            })
            .catch(error => console.log(error)))
    },
    fetchApartment ({ commit }, id) {
        return new Promise(resolve => fetchApartment(id)
            .then(res => {
                commit('setApartment', res.data)
                resolve()
            })
            .catch(error => console.log(error)))
    },
    /* eslint-disable no-unused-vars */
    removeApartment ({ dispatch }, id) {
        return removeApartment(id)
    }
}

const mutations = {
    setApartments (state, apartments) {
        state.apartments = apartments
    },
    setApartment (state, apartment) {
        state.apartment = apartment
    }
}

const getters = {
    interbonApartments: (state) => {
        return state.apartments.filter(apartment => !apartment.isBokalApartment);
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}